import React, { useContext, useState } from 'react';
import { ModalContext } from '../../contexts/ModalContext.js';
import { Link } from 'react-router-dom';
import ModalBlocker from '../../components/ModalBlocker/ModalBlocker.jsx';
import HeroSection from '../../components/Herosection/HeroSection.jsx';
import AnimatedSection from '../../components/AnimatedSection/AnimatedSection.jsx';
import wp4 from '../../assets/wp4.webp';
import wp11 from '../../assets/wp11.webp';
import wp6 from '../../assets/wp6.webp';
import wp15 from '../../assets/wp15.webp';
import wp16 from '../../assets/wp16.webp';
import wp7 from '../../assets/wp7.webp';
import preview from '../../assets/nexark-preview.webp'
import './homepage.scss';

const Homepage = () => {
	const [modalImage, setModalImage] = useState(null)
	const { isModalOpen, setIsModalOpen } = useContext(ModalContext);

	const handleImageModal = (src) => {
		setIsModalOpen(prev => !prev)
		setModalImage(src)
	}

	return (
		<>
			<div className='main-wrapper homepage-wrapper'>
				<HeroSection name={'NEXARK'} height={400} />
        <AnimatedSection
          isReverse={false}
          imageSrc={preview}
          onImageClick={(e) => handleImageModal(e.currentTarget.src)}
        >
					<h2>Willkommen auf NEXARK</h2>
					<p>Tauche ein in die Welt von NEXARK - einem PvE-Cluster für ARK: Survival Ascended, entwickelt mit Fokus auf Fairness, Performance und echter Community. Ob Baumeister:in, Entdecker:in oder Zähmer:in - hier steht gemeinsamer Spielspaß im Mittelpunkt.</p>
					<p>Mehrere vernetzte Karten ermöglichen dir freies Reisen zwischen den Welten. Spiele in deinem Tempo, erkunde unterschiedliche Biome, zähme mächtige Kreaturen und baue beeindruckende Basen - ganz ohne Pay-to-Win, Stress oder unnötige Einschränkungen.</p>
					<p>Stabile Server, ausgewogene Einstellungen und durchdachte Quality-of-Life-Anpassungen sorgen für ein flüssiges und langfristiges Spielerlebnis. Ziel ist eine Umgebung, in der Zusammenarbeit zählt und Fortschritt sich verdient anfühlt. Einfach ARK direkt in dein Gesicht!</p>
					<p>Du suchst Anschluss, Mitspieler oder einfach Austausch rund um ARK? Der <Link className='link' title='NEXARK Discord' to={'https://discord.gg/E5gPRwfvWS'} rel='noreferrer noopener' target='_blank'><strong>Discord <i className="bi bi-box-arrow-up-right"></i></strong></Link> steht jederzeit offen - egal ob Solo-Spieler oder Tribe.</p>
					<p>Willkommen bei NEXARK. Willkommen zu Hause.</p>
				</AnimatedSection>
				<AnimatedSection
					isReverse={true}
          imageSrc={wp11}
          onImageClick={(e) => handleImageModal(e.currentTarget.src)}
				>
					<h2>Server-Performance & Neustarts</h2>
					<p>Um dir ein flüssiges, stabiles und sicheres Spielerlebnis auf NEXARK zu ermöglichen, führen wir täglich automatisierte Server-Neustarts durch. Diese kurzen Wartungsfenster sorgen für:</p>
					<ul>
						<li><strong>Server-Performance </strong>(Vermeidung von Lags und Speicherproblemen)</li>
						<li><strong>Sichere Backups</strong> deiner Spielfortschritte</li>
						<li><strong>Stabilität</strong> über längere Sessions hinweg</li>
					</ul>
					<h3>Tägliche Restart-Zeiten (CET/CEST):</h3>
					<ul>
						<li>07:30 - 08:00 Uhr (Wartungs- & Update Zeitfenster) </li>
						<li>16:00 Uhr</li>
						<li>00:00 Uhr</li>
					</ul>
					<div className="info-box">
						<h4 className='link'>Taming-Tipp:</h4>
						<p>Zähmvorgänge werden durch Server-Restarts gewöhnlich nicht unterbrochen.</p>
						<p>Plane bei wichtigen Dinos sicherheitshalber trotzdem ein wenig Pufferzeit ein.</p>
					</div>
				</AnimatedSection>
				<AnimatedSection
					isReverse={false}
          imageSrc={wp4}
          onImageClick={(e) => handleImageModal(e.currentTarget.src)}
				>
					<h2>Regelmäßiger Dino-Wipe</h2>
					<p>Alle 4 Tage führen wir einen automatisierten Wipe der wilden Dinos durch:</p>
					<p>Wann genau Dino-Wipes stattfinden kannst du unserem Discord entnehmen. Aktuell sind die Wipes wie folgt festgelegt: <strong>Alle 4 Tage um 17:30 Uhr (CET/CEST)</strong></p>
					<p>Warum?</p>
					<ul>
						<li>Damit sich die Wildnis regelmäßig <strong>erneuert</strong></li>
						<li>Um festgefahrene Spawns aufzubrechen</li>
						<li>Damit du bessere Chancen auf <strong>hochlevelige Dinos</strong> hast</li>
						<li>Und damit du <strong>nicht stundenlang grinden musst</strong>, nur um einen max-level T-Rex zu finden</li>
					</ul>
					<p>Der Wipe betrifft nur wilde Dinos - gezähmte Kreaturen sind <strong>nicht betroffen</strong>.</p>
					<div className="info-box">
						<h4 className='link'>Keine Sorge um deine Dinos!</h4>
						<p>Der Wipe trifft nur wilde Kreaturen. Laufende Zähmungen bleiben in der Regel erhalten - um auf Nummer sicher zu gehen, verschiebe dein Taming aber lieber auf die Zeit nach dem Wipe.</p>
					</div>
				</AnimatedSection>
				<AnimatedSection
					isReverse={true}
          imageSrc={wp15}
          onImageClick={(e) => handleImageModal(e.currentTarget.src)}
				>
					<h2>Level- & Stat-Einstellungen</h2>
					<p>Unsere Dino-Wildlevel entsprechen dem offiziellen Standard:</p>
					<p><strong>Normale Dinos bis Level 150, Tek-Dinos bis 180</strong> und <strong>Wyvern bis 190</strong> - so bleibt das Zähmen spannend und ausgewogen.</p>
					<p>Gezähmte Kreaturen erhalten gezielt angepasste Stats: mehr Ausdauer, Tragkraft oder Bewegungsgeschwindigkeit. Auch Spieler:innen profitieren von besserem Gewicht, schnellerem Crafting und erhöhter Resistenz.</p>
					<ul>
						<li><strong>Dino Level Wild</strong></li>
						<ul>
							<li><strong>Normal</strong>: 150</li>
							<li><strong>Tek</strong>: 180</li>
							<li><strong>Wyvern</strong>: 190</li>
						</ul>
						<li><strong>Per Level Stats Multiplier</strong></li>
						<ul>
							<li><strong>Dino gezähmt</strong>: Health x0.5</li>
							<li><strong>Dino gezähmt</strong>: Stamina x3</li>
							<li><strong>Dino gezähmt</strong>: Weight x5</li>
							<li><strong>Dino gezähmt</strong>: Melee x0.5</li>
							<li><strong>Dino gezähmt</strong>: Speed x8</li>
							<li><strong>Spieler</strong>: Weight x2</li>
							<li><strong>Spieler</strong>: TemperatureFortitude x5</li>
							<li><strong>Spieler</strong>: CraftingSpeedMultiplier x2</li>
						</ul>
					</ul>
					<div className="info-box">
						<h4 className='link'>Warum?</h4>
						<p>Diese Anpassungen bieten <strong>mehr Komfort und Spielfluss</strong>, ohne das PvE-Balancing zu kippen - ideal für Solo-Spieler und kleinere Tribes.</p>
					</div>
				</AnimatedSection>
				<AnimatedSection
					isReverse={false}
          imageSrc={wp6}
          onImageClick={(e) => handleImageModal(e.currentTarget.src)}
				>
					<h2>Server-Raten</h2>
					<p>Unsere Server-Raten sind sorgfältig ausgewählt, um ein <strong>balanciertes PvE-Erlebnis</strong> zu bieten - mit dem nötigen <strong>Grind-Faktor</strong>, aber ohne Frust. Egal ob Zähmung, Zucht oder Ernte: Du kommst stetig voran, ohne den Spielspaß zu verlieren.</p>
					<h3>Zähmen, Brüten & Aufziehen</h3>
					<ul>
						<li><strong>Zähmungsgeschwindigkeit</strong>: x1.5</li>							
						<ul>
							<li>z.B. (Lvl 150, Kibble): Giga ≈ 50 Min · Rex ≈ 35 Min · Quetzal ≈ 1h</li>
						</ul>
						<li><strong>Inkubationsgeschwindigkeit</strong>: x7.5</li>
						<ul>
							<li>Giga ≈ 6h 40min · Rex ≈ 40min · Quetzal ≈ 2h 10min</li>
						</ul>
						<li><strong>Wachstumsrate</strong>: x25.0</li>
						<ul>
							<li>Giga ≈ 9h 45min · Rex ≈ 3h 40min · Quetzal ≈ 5h 15min</li>
						</ul>
						<li><strong>Paarungsintervall</strong>: x0.0044</li>
						<ul>
							<li>Paarungscooldown zwischen 5 - 13 Minuten</li>
						</ul>
					</ul>
					<div className="info-box">
						<h4 className='link'>Info</h4>
						<p>Für genauere Info's zu deiner Zähmung, suche den passenden Dino bei <strong><a className='link' href='https://www.dododex.com' target='_blank' rel='noreferrer noopener'>Dododex <i className="bi bi-box-arrow-up-right"></i></a> </strong>und gib sein Level ein. Stell die <em>Taming Speed</em> auf <strong>1,5</strong>.</p>
					</div>
					<h3>Weitere Anpassungen</h3>
					<ul>
						<li><strong>Wasserverbrauch</strong>: x0.8 (seltener Durst)</li>
						<li><strong>Nahrungsverbrauch</strong>: x0.6 (langsamer Hunger)</li>
						<li><strong>Ausdauerverbrauch</strong>: x0.8 (längeres Durchhalten)</li>
						<li><strong>Spieler-Ernteschaden</strong>: x3.0</li>
						<li><strong>Ernteertrag</strong>: x5.0</li>
						<li><strong>Eierlege-Faktor</strong>: x0.4 (mehr unbefruchtete Eier)</li>
						<li><strong>Fischloot-Qualität</strong>: x2.0</li>
						<li><strong>Airdrop-Lootqualität</strong>: x1.25</li>
					</ul>
				</AnimatedSection>
				<AnimatedSection
					isReverse={true}
          imageSrc={wp16}
          onImageClick={(e) => handleImageModal(e.currentTarget.src)}
				>
					<h2>Verfalls Einstellungen</h2>
					<p>Damit unsere Server sauber und performant bleiben, gelten automatische Verfallszeiten für ungenutzte Strukturen und Dinos. Je nach Baumaterial unterscheiden sich die Fristen - von 10 Tagen bei Strohhütten bis zu 50 Tagen bei Tek-Bauten. Gezähmte Dinos verfallen nach 20 Tagen Inaktivität.</p>
					<p>Diese Mechanik hilft dabei, verlassene Basen oder gestackte Flächen regelmäßig zu bereinigen und Platz für aktive Spieler:innen zu schaffen. Wer längere Zeit nicht online sein kann, meldet sich einfach bei uns - wir finden eine Lösung!</p>
					<p>So bleibt die Welt lebendig und fair für alle. (Längere Abwesenheiten können uns mitgeteilt werden)</p>
					<h3>Verfallszeiten für Strukturen und Dinos</h3>
					<ul>
						<li><strong>Thatch / Stroh</strong>: 10 Tage</li>
						<li><strong>Wood / Holz</strong>: 20 Tage</li>
						<li><strong>Adobe / Lehm</strong>: 20 Tage</li>
						<li><strong>Stone / Stein</strong>: 30 Tage</li>
						<li><strong>Metal / Metall</strong>: 40 Tage</li>
						<li><strong>Tek / Tek</strong>: 50 Tage</li>
						<li><strong>Dinos</strong>: 20 Tage</li>
					</ul>
					<div className="info-box">
						<h4 className='link'>Urlaubsmodus für deine Basis:</h4>
						<p>Du bist länger weg? Wir können den Verfallstimer für deine Strukturen bereichsbasiert einfrieren. Melde dich vor deinem Urlaub einfach kurz im Discord, damit deine Basis sicher bleibt. Pack nur deine Dinos ein! (Kryokapsel + Kammer)</p>
					</div>
				</AnimatedSection>
				<AnimatedSection
					isReverse={false}
          imageSrc={wp7}
          onImageClick={(e) => handleImageModal(e.currentTarget.src)}
				>
					<h2>Eigener Discord Bot</h2>
					<p>Unser individuell selbst entwickelter NEXARK Discord Bot verbindet deinen Ingame-Account nahtlos mit unserer Discord-Community. Er kümmert sich im Hintergrund nicht nur um automatisierte Wartungen und den clusterweiten Schutz, sondern belohnt dich auch direkt für deine Spielzeit auf allen 10 Servern.</p>
					<p>Über einfache Befehle kannst du dein Profil verwalten, an regelmäßigen Community-Events teilnehmen oder deine gesammelten NEXCoins in Giveaways setzen. Ganz ohne komplizierte Einrichtung - einfach Account verknüpfen und sofort alle Features nutzen!</p>
					<p>So hast du deinen Spielfortschritt, Raten-Events und den Cluster-Status jederzeit im Blick.</p>

					<h3>Bot-Features & Community-Vorteile</h3>
					<ul>
						<li><strong>NEXCoins System</strong>: Verdiene automatisch NEXCoins pro Minute Spielzeit und nutze sie für Giveaways & Fundraising Events (Noch mehr geplant!).</li>
						<li><strong>Täglicher Login-Bonus</strong>: Sichere dir jeden Tag zusätzliche Coins beim ersten Joinen auf den Servern.</li>
						<li><strong>Echte Ingame-Verknüpfung</strong>: Verknüpfe deinen Account per `/link` für automatische Rollen und Profil-Statistiken.</li>
						<li><strong>Event- & Fundraising-System</strong>: Die Community kann gemeinsam NEXCoins beisteuern, um Server-Raten (XP, Harvest, Taming, Breeding) freizuschalten.</li>
						<li><strong>Giveaways</strong>: Nimm mit deinen NEXCoins an exklusiven Verlosungen im Discord teil.</li>
						<li><strong>Status & Transparenz</strong>: Live-Serverstatus, Ankündigungen für Wild-Dino-Wipes, automatische Restart-Warnungen und ein 2FA System für's verlinken - damit auch ganz sicher nur du dich verlinken kannst.</li>
					</ul>

					<div className="info-box">
						<h4 className='link'>Einfach starten:</h4>
						<p>Verwende im Discord einfach den Befehl <code>/link</code> (während du auf einem unserer Server bist) und gib deine Ingame EOS-ID ein. Schon ist dein Profil aktiv, deine Coins sammeln sich automatisch und du schaltest alle Community-Funktionen frei!</p>
					</div>
				</AnimatedSection>
			</div>
			{isModalOpen && <ModalBlocker setModalImage={setModalImage} imageOnly={true} imageSrc={modalImage}/>}
		</>
	)
}

export default Homepage